module.exports = __webpack_public_path__ + "img/tel.6387351f.png";